import { formatOperationsMetric } from './operationsMetrics.js';

export const PROJECT_OPERATIONS_LABELS = {
  in_progress: '正在进行',
  completed: '已完成',
  under_review: '审核中',
  approved: '已过审',
  published: '已上架',
  delayed: '延期',
};
export const projectOperationsStatus = project => {
  const rawStatus = project?.operationsSummary?.status;
  const status = rawStatus === 'unlisted' ? 'in_progress' : rawStatus === 'submitted' ? 'completed' : rawStatus;
  return Object.hasOwn(PROJECT_OPERATIONS_LABELS, status) ? status : 'in_progress';
};

// Metadata endpoints do not hydrate this read-only summary. Their null must not
// erase the latest list snapshot; a new /project/list response remains authoritative.
export const mergeProjectMetadata = (previous, incoming) => ({
  ...previous, ...incoming,
  operationsSummary: incoming?.operationsSummary ?? previous?.operationsSummary,
});

// Classify the original value, never the rounded 万/亿 display string.
export function getProjectHeatTier(value) {
  const text = String(value ?? '').trim();
  if (!/^\d+(?:\.\d+)?$/.test(text)) return 'gray';
  const whole = BigInt(text.split('.')[0]);
  if (whole >= 70000000n) return 'orange';
  if (whole >= 60000000n) return 'purple';
  if (whole >= 50000000n) return 'blue';
  if (whole >= 40000000n) return 'green';
  return 'gray';
}

/** Decimal strings stay decimal strings; compact rounding uses integer arithmetic. */
export function compactProjectMetric(value) {
  if (value === null || value === undefined || value === '') return null;
  const text = String(value).trim();
  if (!/^\d+(?:\.\d+)?$/.test(text)) return null;
  const [rawWhole, rawFraction = ''] = text.split('.');
  const whole = BigInt(rawWhole).toString();
  const fraction = rawFraction.replace(/0+$/, '');
  const normalized = whole + (fraction ? `.${fraction}` : '');
  const original = formatOperationsMetric(normalized);
  const shift = BigInt(whole) >= 100000000n ? 8 : BigInt(whole) >= 10000n ? 4 : 0;
  if (!shift) return { text: original, original };
  const scale = fraction.length + shift;
  const digits = BigInt(whole + fraction);
  const divisor = 10n ** BigInt(scale - 2);
  const quotient = digits / divisor;
  const remainder = digits % divisor;
  const rounded = quotient + (remainder * 2n >= divisor ? 1n : 0n);
  const scaled = rounded.toString().padStart(3, '0');
  const decimal = scaled.slice(-2).replace(/0+$/, '');
  return { text: `${remainder ? '≈' : ''}${scaled.slice(0, -2)}${decimal ? `.${decimal}` : ''}${shift === 8 ? '亿' : '万'}`, original };
}
